import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100vh",
    padding: theme.spacing.space16,
  },
  description: {
    marginTop: theme.spacing.space16,
    marginBottom: theme.spacing.space16,
  },
  button: {
    height: 34,
  },
}));
